import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Teams = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.7674 3.61628C10.7674 4.71365 9.93218 5.61594 8.86272 5.72211V5.03333C8.86272 4.31715 8.28214 3.73655 7.5659 3.73655H6.53816C6.53599 3.69674 6.5348 3.65664 6.5348 3.61628C6.5348 2.44749 7.48232 1.5 8.65111 1.5C9.8199 1.5 10.7674 2.44749 10.7674 3.61628Z"
      fill="currentColor"
    />
    <path
      d="M14.6744 4.27377C14.6744 5.08293 14.0184 5.73888 13.2093 5.73888C12.4001 5.73888 11.7442 5.08293 11.7442 4.27377C11.7442 3.46461 12.4001 2.80865 13.2093 2.80865C14.0184 2.80865 14.6744 3.46461 14.6744 4.27377Z"
      fill="currentColor"
    />
    <path
      d="M12.7158 12.576C12.6183 12.576 12.5223 12.5699 12.4281 12.558C12.6605 12.0078 12.7834 11.4008 12.7697 10.7652V7.02272C12.7734 6.79452 12.7185 6.57878 12.6187 6.39H14.3814C14.7231 6.39 15 6.66698 15 7.00858V10.3025C15 11.5582 13.9821 12.576 12.7265 12.576H12.7158Z"
      fill="currentColor"
    />
    <path
      d="M5.19949 12.2993H7.56584C8.28208 12.2993 8.86266 11.7187 8.86266 11.0026V6.39H11.473C11.8105 6.39835 12.0775 6.67853 12.0697 7.01607V10.773C12.1169 12.7988 10.5141 14.48 8.48837 14.5295C7.00416 14.4932 5.74705 13.5812 5.19949 12.2993Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.59678 4.43655H7.56601C7.89557 4.43655 8.16276 4.70374 8.16276 5.03333V11.0026C8.16276 11.3321 7.89557 11.5993 7.56601 11.5993H1.59678C1.26719 11.5993 1 11.3321 1 11.0026V5.03333C1 4.70374 1.2672 4.43655 1.59678 4.43655ZM6.11302 6.87313V6.17313H2.96302V6.87313H4.18802V10.0231H4.88802V6.87313H6.11302Z"
      fill="currentColor"
    />
  </Icon>
));

export default Teams;
